<div class="main container-fluid">
    <p>test works!</p>
<button (click)="loadAgency()">Load Data</button>


<div class="row">
    <div class="col">
        Agency <br>
     <mat-selection-list style="height: 500px; overflow-y: auto;" #shoes (selectionChange)="agencyselected($event)" [multiple]="false">
        <mat-list-option *ngFor="let a of list_agency; let i = index" [value]="a">
          {{i + 1}}.{{a.agencyDetails.agencyName}} {{a.agencyDetails.abbreviation}}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="col">
        Citizens Charter <br>

        <mat-selection-list #shoess (selectionChange)="citizensCharterChange($event)" [multiple]="false">
            <mat-list-option *ngFor="let a of list_cc; let i = index" [value]="a">
              {{i + 1}}.{{a.dateSubmitted.toDate() | date: 'MMM dd, yyyy'}}

              <button >Delete</button>
            </mat-list-option>
          </mat-selection-list>
    </div>
    <div class="col">
        Services <br>

        <mat-selection-list #shoesss   [multiple]="false">
            <mat-list-option *ngFor="let a of list_service; let i = index" [value]="a">
              {{i + 1}}.{{a.serviceDetails.service_name}} ({{a.posted_status}})
            </mat-list-option>
          </mat-selection-list>
    </div>
    <div class="col"> 
        Worklist <br>

        <mat-selection-list #shoesss  [multiple]="false">
            <mat-list-option *ngFor="let a of list_worklist; let i = index" [value]="a">
              {{i + 1}}.{{a.documentTitle}}
            </mat-list-option>
          </mat-selection-list>
    </div>
    <div class="col"> 
        Certificate of Compliance <br>

        <mat-selection-list #shoesss  [multiple]="false">
            <mat-list-option *ngFor="let a of list_coc; let i = index" [value]="a">
              {{i + 1}}.{{a.cocYear}}
            </mat-list-option>
          </mat-selection-list>
    </div>
</div>








</div>